/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, February 2022
 * @format
 * @flow
 */

import React from 'react';
import PropTypes from 'prop-types';
import ChecksWithGroup from '../ChecksWithGroup';
import classes from './CheckList.module.css';

const CheckList = props => {
  const {
    checkList,
    onSelectCheck,
    selectedCheck,
    showPopup,
    currentMode,
    onClickCheckFooterButton,
    checkFilters,
    checkSortFunction,
    ascending,
    checkIdsMap,
    sensorsMap,
  } = props;

  return (
    <div className={classes.checksContainer}>
      <ChecksWithGroup
        checks={checkList}
        onSelectCheck={onSelectCheck}
        selectedCheck={selectedCheck}
        showPopup={showPopup}
        currentMode={currentMode}
        onClickCheckFooterButton={onClickCheckFooterButton}
        checkFilters={checkFilters}
        checkSortFunction={checkSortFunction}
        ascending={ascending}
        checkIdsMap={checkIdsMap}
        sensorsMap={sensorsMap}
      />
    </div>
  );
};

export default CheckList;

CheckList.propTypes = {
  checkList: PropTypes.array,
  onSelectCheck: PropTypes.func,
  selectedCheck: PropTypes.object,
  showPopup: PropTypes.func,
  currentMode: PropTypes.string,
  onClickCheckFooterButton: PropTypes.func,
  checkFilters: PropTypes.object,
  checkSortFunction: PropTypes.func,
  ascending: PropTypes.bool,
  checkIdsMap: PropTypes.instanceOf(Map),
  sensorsMap: PropTypes.instanceOf(Map),
};

CheckList.defaultProps = {
  checkList: [],
  onSelectCheck: () => { },
  selectedCheck: {},
  showPopup: () => { },
  currentMode: '',
  onClickCheckFooterButton: () => { },
  checkFilters: {},
  checkSortFunction: () => { },
  ascending: true,
  checkIdsMap: new Map(),
  sensorsMap: new Map(),
};
